import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const purchaseCreditNoteURL = `api/v1/purchase-app/dr-cr-notes`;

//obtaining the paginated data
export const getPurchaseCreditNote = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseCreditNoteURL}/list?note_type=purchase_credit&${paginationQueryParams(
      rowsPerPage,
      search,
      sortOrder,
      pageNo
    )}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPurchaseCreditNote = () => axiosInstance.get(`${purchaseCreditNoteURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePurchaseCreditNote = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${purchaseCreditNoteURL}/list?note_type=purchase_credit&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );

export const getPurchaseCreditNoteAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

// get by id
export const getPurchaseCreditNoteById = (id) => axiosInstance.get(`${purchaseCreditNoteURL}/retrieve/${id}`);

// fetch purchase invoice details
export const getPurchaseCreditNoteDetailsById = (id) =>
  axiosInstance.get(`api/v1/purchase-app/purchase-invoice/retrieve/${id}`);

//creating function
export const createPurchaseCreditNote = (body) => axiosInstance.post(`${purchaseCreditNoteURL}/create`, body);
//updating function
export const updatePurchaseCreditNote = (id, body) =>
  axiosInstance.patch(`${purchaseCreditNoteURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseCreditNoteURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}&note_type=purchase_credit`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
